/* tslint:disable */
import { RefEquipment } from './ref-equipment';

/**
 */
export class ResultBuildForNewTR {
    RefEquipment?: RefEquipment[];
    CheckKernel?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/result-build-for-new-tr.ts